/* W&M Tools draft: homepage carousels — Shop by category (arrows + progress line), Fieldforce tools and Best sellers on phone (progress line),
   and the swipeable product / staged shot inside each Best seller card (dots). */
(function () {
  function setup(track, opts) {
    if (!track || track.dataset.car) return;
    track.dataset.car = '1';
    var nav = null, prev = null, next = null;
    if (opts.arrows) {
      var sec = track.closest('.wmt-sec');
      var head = sec && sec.querySelector('.wmt-sh');
      nav = document.createElement('div');
      nav.className = 'wmt-car-nav';
      nav.innerHTML = '<button type="button" class="wmt-car-btn" aria-label="Previous">←</button><button type="button" class="wmt-car-btn" aria-label="Next">→</button>';
      prev = nav.children[0]; next = nav.children[1];
      if (head) {
        var link = head.querySelector('.wmt-ul');
        var right = document.createElement('div');
        right.className = 'wmt-sh__r';
        if (link) right.appendChild(link);
        right.appendChild(nav);
        head.appendChild(right);
      }
    }
    var bar = document.createElement('div');
    bar.className = 'wmt-car-bar';
    bar.innerHTML = '<span></span>';
    track.parentNode.insertBefore(bar, track.nextSibling);
    var fill = bar.firstChild;
    function step() {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      fill.style.width = (ratio * 100) + '%';
      fill.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
      bar.style.display = max > 2 ? '' : 'none';
      if (nav) {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        nav.style.visibility = max > 2 ? '' : 'hidden';
      }
    }
    if (nav) {
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function cardDots() {
    document.querySelectorAll('.wmt .wmt-card__im--2').forEach(function (im) {
      var t = im.querySelector('.wmt-card__track'), dots = im.querySelectorAll('.wmt-card__dots i');
      if (!t || t.dataset.dots) return; t.dataset.dots = '1';
      t.addEventListener('scroll', function () {
        var k = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
      }, { passive: true });
    });
  }
  function init() {
    setup(document.querySelector('.wmt .wmt-cats'), { arrows: true });
    setup(document.querySelector('.wmt .wmt-tools'), { arrows: false });
    setup(document.querySelector('.wmt .wmt-grid4'), { arrows: false });
    cardDots();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();